<script setup>
</script>

<template>    
<div id="credits" class="fw-bg">
  <p class="S m-0 center grey-text p-1 pt-05">
      <i class="fa fa-heart mini-text heart" aria-hidden="true"></i>&nbsp;
      Proudly <i>fully custom</i> designed & developed by&nbsp;
      <a href="https://www.uwa.agency/" target="_blank" class="fb-text hover-col">
          <img src="https://mini.uwa.agency/img/uwa/brand/uwa_logo.svg" class="img" alt="UWA logo" style="display: inline-block; width: 26px; transform: translate(0, 25%);"/>
      </a>&nbsp;
      using&nbsp;
      <a href="https://mini.uwa.agency/" target="_blank" class="fb-text link-hover-text">
          <img src="https://mini.uwa.agency/img/brand/mini_emblem.svg" class="img" alt="mini logo" style="display: inline-block; width: 16px;"/>&nbsp;
          mini
      </a>
  </p>
</div>
</template>

<style lang="scss" scoped>
</style>
